import i18n from '@/plugins/i18n';

const guageChart = [
  {
    width: '18%',
    widthInPer: '100%',
    title: '',
    height: '12.5em',
    entityType: 'Service',
    enabled: true,
    type: 'percentageView',
    chartBoxStyle: { height: 'auto' },
    configureRange: true,
    rangeProps: {
      leftFillColor: 'rgb(151, 193, 103)',
      rightFillColor: 'rgb(64, 84, 190)',
      labelText: '',
    },
    configureLabels: true,
    labelProps: {
      label0Text: '0 %',
      label50Value: 50,
      label50Text: '50 %',
      label100Value: 100,
      label100Text: '100 %',
    },
    axisMax: 100,
    independentSelector: false,
    metricType: 'REGULAR_VALUE',
    metricName: 'mobile_app_android_crash_percent',
    queryMetricType: 'readMetricsValue',
    chartType: 'ChartGauge',
    aggregation: '/',
    aggregationNum: '100',
    showGuageLegends: true,
    leftLabel: i18n.global.t('android'),
    rightLabel: i18n.global.t('ios'),
    getChartColor: (val) =>
      val < 0 ? 'rgb(255 ,255 ,255)' : 'rgb(151, 193, 103)',
    getTrackBackground: (val) =>
      val < 0 ? 'rgb(255 ,255 ,255)' : 'rgb(64, 84, 190)',
    formatValue: () => '',
    formatSeries: (val) => [val],
  },
];

export default { guageChart };
